export default __webpack_public_path__ + "static/media/github_icon.699ad349.png";